export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 p-8 md:p-12 lg:p-16">
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/10 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-white/10 blur-3xl"></div>
          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
                加入吃瓜社区，瓜友都在这里
              </h2>
              <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-lg mb-6">
                扫码关注我们的社交媒体账号，第一时间获取最新吃瓜推送。
                每日精选内容直达你的手机，和百万瓜友一起讨论最热话题。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/20 text-white rounded-full text-sm font-medium backdrop-blur-sm cursor-pointer whitespace-nowrap">
                  <i className="ri-wechat-line"></i>
                  关注公众号
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/20 text-white rounded-full text-sm font-medium backdrop-blur-sm cursor-pointer whitespace-nowrap">
                  <i className="ri-weibo-line"></i>
                  关注微博
                </span>
              </div>
            </div>
            <div className="w-40 h-40 md:w-48 md:h-48 bg-white rounded-3xl flex items-center justify-center">
              <div className="text-center">
                <i className="ri-qr-code-line text-5xl text-primary-500"></i>
                <p className="text-xs text-foreground-500 mt-2">扫码关注</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}